import { useEffect, useState } from 'react';
import { CardTitle, todayInputStyle, TodayCard } from './primitives';

const SLOT_PLACEHOLDERS = ['Something small...', 'Someone who helped...', 'A moment that landed right...'] as const;

/**
 * Row B (420px) — Today I'm grateful for (R8.6, design/screens/
 * today-desktop-v2.md SS7.2). Exactly 3 numbered slots, each independently
 * optional and independently persisted (AC-T17) — no forced order, no "fill
 * 1 before 2" validation, no counter chrome (gratitude has no cap concept).
 */
export function GratitudeCard({
  gratitude,
  onSetSlot,
}: {
  readonly gratitude: readonly [string, string, string];
  readonly onSetSlot: (slot: 0 | 1 | 2, text: string) => void;
}) {
  return (
    <TodayCard label="Today I'm grateful for" style={{ width: '420px', flex: 'none' }}>
      <CardTitle>Today I&apos;m grateful for</CardTitle>
      <div style={{ marginTop: 'var(--space-4)', display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
        {([0, 1, 2] as const).map((slot) => (
          <GratitudeSlotRow
            key={slot}
            slot={slot}
            value={gratitude[slot]}
            placeholder={SLOT_PLACEHOLDERS[slot]}
            onCommit={(text) => onSetSlot(slot, text)}
          />
        ))}
      </div>
    </TodayCard>
  );
}

function GratitudeSlotRow({
  slot,
  value,
  placeholder,
  onCommit,
}: {
  readonly slot: 0 | 1 | 2;
  readonly value: string;
  readonly placeholder: string;
  readonly onCommit: (text: string) => void;
}) {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
      <span
        className="num"
        style={{ flex: 'none', width: '20px', fontSize: 'var(--type-caption-size)', color: 'var(--text-muted)' }}
      >
        {String(slot + 1).padStart(2, '0')}
      </span>
      <input
        aria-label={`Gratitude slot ${slot + 1}`}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={() => {
          if (draft !== value) onCommit(draft);
        }}
        placeholder={placeholder}
        style={todayInputStyle}
      />
    </div>
  );
}
